// arAppealSelectionsStore.ts
import { create } from 'zustand';

interface ArAppealSelectionsState {
  selectedKeys: string[]; // Array of invoiceIds
  setSelectedKeys: (value: string[]) => void;
  toggleSelection: (invoiceId: string) => void;
  selectAll: (invoiceIds: string[]) => void;
  clearSelections: () => void;
}

export const useArAppealSelectionsStore = create<ArAppealSelectionsState>()(set => ({
  selectedKeys: [],

  setSelectedKeys: value =>
    set(() => ({
      selectedKeys: value,
    })),

  toggleSelection: invoiceId =>
    set(state => {
      const isSelected = state.selectedKeys.includes(invoiceId);
      return {
        selectedKeys: isSelected
          ? state.selectedKeys.filter(key => key !== invoiceId)
          : [...state.selectedKeys, invoiceId],
      };
    }),

  selectAll: invoiceIds =>
    set(() => ({
      selectedKeys: invoiceIds,
    })),

  clearSelections: () =>
    set(() => ({
      selectedKeys: [],
    })),
}));
